(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.announcement-bar').forEach(function (bar) {
      var track = bar.querySelector('.announcement-bar__track');
      if (!track) return;

      var slides = Array.from(track.querySelectorAll('.announcement-bar__slide'));
      if (slides.length === 0) return;

      if (slides.length === 1) {
        slides[0].classList.add('is-active');
        return;
      }

      var speed = (parseInt(bar.dataset.speed, 10) || 4) * 1000;
      var current = 0;
      var timer;

      slides[0].classList.add('is-active');

      function next() {
        var prev = current;
        current = (current + 1) % slides.length;

        slides[prev].classList.add('is-exit');
        slides[prev].classList.remove('is-active');
        slides[current].classList.add('is-active');

        slides[prev].addEventListener('transitionend', function onEnd() {
          slides[prev].classList.remove('is-exit');
          slides[prev].removeEventListener('transitionend', onEnd);
        });
      }

      function start() { timer = setInterval(next, speed); }
      function stop() { clearInterval(timer); }

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.collection-grid').forEach(function (el) {
      var track = el.querySelector('.collection-grid__track');
      var prevBtn = el.querySelector('.collection-grid__btn--prev');
      var nextBtn = el.querySelector('.collection-grid__btn--next');

      if (!track || !prevBtn || !nextBtn) return;

      function getScrollAmount() {
        var card = track.querySelector('.collection-card');
        if (!card) return 300;
        var gap = parseFloat(getComputedStyle(track).gap) || 12;
        return card.offsetWidth + gap;
      }

      function updateButtons() {
        prevBtn.style.opacity = track.scrollLeft <= 0 ? '0.3' : '1';
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        nextBtn.style.opacity = atEnd ? '0.3' : '1';
      }

      track.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {

    // ===== Filters =====
    var filterPanel = document.getElementById('filter-panel');
    var mobileBtn = document.getElementById('filter-mobile-open');

    // Mobile drawer
    var filterOverlay = document.getElementById('filter-overlay');
    var filterCloseBtn = document.getElementById('filter-mobile-close');
    var filterApplyBtn = document.getElementById('filter-drawer-apply');

    function openFilterDrawer() {
      filterPanel.classList.add('is-open');
      if (filterOverlay) filterOverlay.classList.add('is-open');
      if (mobileBtn) mobileBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilterDrawer() {
      filterPanel.classList.remove('is-open');
      if (filterOverlay) filterOverlay.classList.remove('is-open');
      if (mobileBtn) mobileBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (mobileBtn && filterPanel) {
      mobileBtn.addEventListener('click', openFilterDrawer);
    }
    if (filterCloseBtn) filterCloseBtn.addEventListener('click', closeFilterDrawer);
    if (filterOverlay) filterOverlay.addEventListener('click', closeFilterDrawer);

    // Don't close details on outside click if the filter is active (has open attr from server)
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.filter-group[open]').forEach(function (details) {
        if (!details.contains(e.target) && !details.hasAttribute('data-keep-open')) {
          details.removeAttribute('open');
        }
      });
    });

    // Build a combined filter URL from all currently checked checkboxes
    function buildFilterUrl() {
      var newParams = new URLSearchParams();
      // Preserve non-filter params (e.g. sort_by)
      new URLSearchParams(window.location.search).forEach(function (val, key) {
        if (!key.startsWith('filter.')) newParams.append(key, val);
      });
      // Add each checked checkbox's filter param
      document.querySelectorAll('.filter-checkbox:checked').forEach(function (cb) {
        var addParams = new URLSearchParams(new URL(cb.getAttribute('data-url-add'), location.origin).search);
        var removeParams = new URLSearchParams(new URL(cb.getAttribute('data-url-remove'), location.origin).search);
        addParams.forEach(function (val, key) {
          if (key.startsWith('filter.') && !removeParams.getAll(key).includes(val)) {
            newParams.append(key, val);
          }
        });
      });
      var str = newParams.toString();
      return window.location.pathname + (str ? '?' + str : '');
    }

    // Checkboxes: immediate on desktop, deferred on mobile
    document.querySelectorAll('.filter-checkbox').forEach(function (cb) {
      cb.addEventListener('change', function () {
        if (window.innerWidth <= 768) return; // mobile: wait for apply button
        window.location.href = cb.checked
          ? cb.getAttribute('data-url-add')
          : cb.getAttribute('data-url-remove');
      });
    });

    // Mobile apply button: navigate with all selected filters
    if (filterApplyBtn) {
      filterApplyBtn.addEventListener('click', function () {
        window.location.href = buildFilterUrl();
      });
    }

    // Sort: add sort_by to current URL (preserves filter params already in URL)
    var sortSelect = document.getElementById('collection-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    // Price range: build URL from current location (preserves filter params + sort)
    document.querySelectorAll('.filter-price').forEach(function (el) {
      var param = el.getAttribute('data-param');
      var minInput = el.querySelector('#filter-price-min');
      var maxInput = el.querySelector('#filter-price-max');
      var applyBtn = el.querySelector('.filter-price__apply');
      if (!applyBtn) return;
      applyBtn.addEventListener('click', function () {
        var url = new URL(window.location.href);
        if (minInput && minInput.value !== '') {
          url.searchParams.set(param + '.gte', minInput.value);
        } else {
          url.searchParams.delete(param + '.gte');
        }
        if (maxInput && maxInput.value !== '') {
          url.searchParams.set(param + '.lte', maxInput.value);
        } else {
          url.searchParams.delete(param + '.lte');
        }
        window.location.href = url.toString();
      });
    });

    // ===== Infinite scroll =====
    var grid = document.getElementById('collection-grid');
    var sentinel = document.querySelector('.collection-page__sentinel');
    var loader = document.querySelector('.collection-page__loader');

    if (!grid || !sentinel) return;

    var loading = false;

    function checkPosition() {
      var rect = sentinel.getBoundingClientRect();
      if (rect.top < window.innerHeight + 500) loadNext();
    }

    function onScroll() {
      if (!loading) checkPosition();
    }

    function loadNext() {
      var nextUrl = sentinel.getAttribute('data-next-url');
      if (!nextUrl || loading) return;

      loading = true;
      if (loader) loader.classList.add('is-loading');

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('#collection-grid .product-card');
          newCards.forEach(function (card) { grid.appendChild(card); });

          var newSentinel = doc.querySelector('.collection-page__sentinel');
          if (newSentinel) {
            sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
            loading = false;
            if (loader) loader.classList.remove('is-loading');
            checkPosition();
          } else {
            observer.disconnect();
            window.removeEventListener('scroll', onScroll);
            sentinel.remove();
            if (loader) loader.remove();
          }
        })
        .catch(function () {
          loading = false;
          if (loader) loader.classList.remove('is-loading');
        });
    }

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) loadNext();
    }, { rootMargin: '500px' });

    observer.observe(sentinel);
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('.contact-page form');
    if (!form) return;

    var honeypot = form.querySelector('#ContactFormWebsite');
    var loadTime = Date.now();

    form.addEventListener('submit', function (e) {
      if (honeypot && honeypot.value !== '') {
        e.preventDefault();
        return;
      }
      if (Date.now() - loadTime < 2000) {
        e.preventDefault();
        return;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.featured-collection--slider').forEach(function (el) {
      var track = el.querySelector('.featured-collection__track');
      var prevBtn = el.querySelector('.featured-collection__btn--prev');
      var nextBtn = el.querySelector('.featured-collection__btn--next');

      if (!track || !prevBtn || !nextBtn) return;

      function getScrollAmount() {
        var card = track.querySelector('.product-card');
        if (!card) return 300;
        var gap = parseFloat(getComputedStyle(track).gap) || 4;
        return card.offsetWidth + gap;
      }

      function updateButtons() {
        prevBtn.style.opacity = track.scrollLeft <= 0 ? '0.3' : '1';
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        nextBtn.style.opacity = atEnd ? '0.3' : '1';
      }

      track.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.footer__col--menu .footer__col-heading');
    if (!btn) return;
    var col = btn.closest('.footer__col--menu');
    var isOpen = col.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Sticky header
    var header = document.querySelector('header.header');
    if (header) {
      var wrapper = header.closest('.shopify-section-group') || header.closest('.shopify-section');
      if (wrapper) {
        wrapper.style.position = 'sticky';
        wrapper.style.top = '0';
        wrapper.style.zIndex = '100';
        wrapper.style.background = 'var(--color-background)';
      }
    }

    // Transparent header over hero
    if (header && wrapper) {
      var nextSection = wrapper.nextElementSibling;
      var hasHero = nextSection && nextSection.querySelector('.hero-banner');
      if (hasHero) {
        nextSection.style.marginTop = '-' + wrapper.offsetHeight + 'px';

        function updateHeaderTransparency() {
          var atTop = window.scrollY < 10;
          var megaOpen = header.querySelector('.header__nav-item--has-children:hover') !== null;
          if (atTop && !megaOpen) {
            header.classList.add('header--transparent');
            wrapper.style.background = 'transparent';
          } else {
            header.classList.remove('header--transparent');
            wrapper.style.background = 'var(--color-background)';
          }
        }
        window.addEventListener('scroll', updateHeaderTransparency, { passive: true });
        updateHeaderTransparency();

        // Keep header opaque while a mega menu is open
        document.querySelectorAll('.header__nav-item--has-children').forEach(function (item) {
          item.addEventListener('mouseenter', function () {
            header.classList.remove('header--transparent');
            wrapper.style.background = 'var(--color-background)';
          });
          item.addEventListener('mouseleave', function () {
            updateHeaderTransparency();
          });
        });
      }
    }

    var searchOverlay = document.querySelector('.header-search');

    // Mobile nav
    var mobileNav = document.getElementById('mobile-nav');
    var menuBtn = document.querySelector('.header__menu-btn');
    var mobileClose = document.querySelector('.mobile-nav__close');
    var mobileOverlay = document.querySelector('.mobile-nav__overlay');

    function openMobileNav() {
      mobileNav.setAttribute('aria-hidden', 'false');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMobileNav() {
      mobileNav.setAttribute('aria-hidden', 'true');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (menuBtn) menuBtn.addEventListener('click', openMobileNav);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

    // Mobile nav sub-menu toggles
    document.querySelectorAll('.mobile-nav__link--parent').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.nextElementSibling;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        sub.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      });
    });

    // Search
    var searchBtns = document.querySelectorAll('.header__search-btn');
    var searchClose = document.querySelector('.header-search__close');
    var searchInput = document.querySelector('.header-search__input');
    var searchResults = document.querySelector('.header-search__results');
    var searchBackdrop = document.querySelector('.header-search__backdrop');
    var searchForm = document.querySelector('.header-search__form');

    if (!searchOverlay || !searchBtns.length) return;
    var searchBtn = searchBtns[0];

    var debounceTimer;
    var searchUrl = searchForm ? searchForm.getAttribute('action') : '/search';
    var allResultsText = searchResults.getAttribute('data-all-results') || 'Alle resultaten bekijken';
    var noResultsText = searchResults.getAttribute('data-no-results') || 'Geen resultaten gevonden';

    function openSearch() {
      searchOverlay.setAttribute('aria-hidden', 'false');
      searchBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { searchInput.focus(); }, 50);
    }

    function closeSearch() {
      searchOverlay.setAttribute('aria-hidden', 'true');
      searchBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      searchResults.innerHTML = '';
      searchInput.value = '';
    }

    function renderResults(data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      var query = searchInput.value.trim();

      if (products.length === 0) {
        searchResults.innerHTML = '<p class="search-no-results">' + noResultsText + '</p>';
        return;
      }

      var html = products.slice(0, 5).map(function (p) {
        var img = p.image
          ? '<div class="search-result__image"><img src="' + p.image + '" alt="" loading="lazy"></div>'
          : '<div class="search-result__image"></div>';
        var price = p.price ? '<p class="search-result__price">' + p.price + '</p>' : '';
        return '<a href="' + p.url + '" class="search-result">'
          + img + '<div><p class="search-result__title">' + p.title + '</p>' + price + '</div>'
          + '</a>';
      }).join('');

      html += '<a href="' + searchUrl + '?q=' + encodeURIComponent(query) + '&type=product" class="search-result__all">' + allResultsText + ' \u2192</a>';
      searchResults.innerHTML = html;
    }

    function fetchSuggestions(query) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5')
        .then(function (res) { return res.json(); })
        .then(renderResults);
    }

    searchBtns.forEach(function (btn) { btn.addEventListener('click', openSearch); });
    searchClose.addEventListener('click', closeSearch);
    if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSearch(); closeMobileNav(); }
    });

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = searchInput.value.trim();
      if (query.length < 2) { searchResults.innerHTML = ''; return; }
      debounceTimer = setTimeout(function () { fetchSuggestions(query); }, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var colorMap = {
      'zwart': '#111', 'black': '#111',
      'wit': '#f9f9f9', 'white': '#f9f9f9',
      'rood': '#dc2626', 'red': '#dc2626',
      'blauw': '#2563eb', 'blue': '#2563eb',
      'navy': '#1e3a5f',
      'groen': '#16a34a', 'green': '#16a34a',
      'grijs': '#9ca3af', 'grey': '#9ca3af', 'gray': '#9ca3af',
      'beige': '#e8d5b7',
      'ecru': '#f5f0e8',
      'camel': '#c19a6b',
      'bruin': '#92400e', 'brown': '#92400e',
      'roze': '#f9a8d4', 'pink': '#f9a8d4',
      'geel': '#fbbf24', 'yellow': '#fbbf24',
      'oranje': '#f97316', 'orange': '#f97316',
      'paars': '#7c3aed', 'purple': '#7c3aed',
      'khaki': '#b5a642',
      'zand': '#c2b280', 'sand': '#c2b280',
      'olijf': '#6b7028', 'olive': '#6b7028',
      'bordeaux': '#6b1b2a', 'burgundy': '#6b1b2a'
    };

    // Shared bundle state: sectionId → { siblings, slotProducts }
    var bundleRegistry = {};

    function formatMoney(cents) {
      return '\u20AC\u00A0' + (cents / 100).toFixed(2).replace('.', ',');
    }

    // ===== Initialize each product section =====
    document.querySelectorAll('[data-product-section]').forEach(function (sectionEl) {
      var sectionId = sectionEl.getAttribute('data-product-section');
      var dataEl = document.getElementById('product-data-' + sectionId);
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants;
      var prices = data.prices;
      var inventory = data.inventory;
      var selectedOptions = data.selectedOptions;
      var btn0 = sectionEl.querySelector('.product-info__add-btn');
      var addToCartText = btn0 ? (btn0.getAttribute('data-add-text') || 'In winkelwagen') : 'In winkelwagen';
      var soldOutText = btn0 ? (btn0.getAttribute('data-sold-out-text') || 'Uitverkocht') : 'Uitverkocht';

      // Sticky top
      var infoEl = document.getElementById('product-info-' + sectionId);
      function setInfoTop() {
        var header = document.querySelector('header.header');
        if (header && infoEl) {
          infoEl.style.top = header.offsetHeight + 'px';
        }
      }
      setInfoTop();
      window.addEventListener('resize', setInfoTop, { passive: true });

      // Color swatches
      sectionEl.querySelectorAll('.opt-btn--color').forEach(function (btn) {
        var color = colorMap[btn.getAttribute('data-color')];
        if (color) btn.style.backgroundColor = color;
      });

      function findVariant(options) {
        return variants.find(function (v) {
          return options.every(function (opt, i) { return v['option' + (i + 1)] === opt; });
        });
      }

      function updatePrice(variant) {
        var el = sectionEl.querySelector('.product-info__price');
        if (!el) return;
        var formatted = prices[variant.id] || {};
        var priceStr = formatted.price || formatMoney(variant.price);
        var compareStr = formatted.compare_at_price || formatMoney(variant.compare_at_price);

        var saleEl = el.querySelector('.product-info__price-sale');
        var compareEl = el.querySelector('.product-info__price-compare');
        var regularEl = el.querySelector('.product-info__price-regular');

        if (saleEl) saleEl.innerHTML = priceStr;
        if (compareEl) compareEl.innerHTML = compareStr;
        if (regularEl) regularEl.innerHTML = priceStr;

        var bespaarEl = document.getElementById('product-bespaar-' + sectionId);
        if (bespaarEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            bespaarEl.removeAttribute('hidden');
          } else {
            bespaarEl.setAttribute('hidden', '');
          }
        }

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          el.classList.add('has-sale');
        } else {
          el.classList.remove('has-sale');
        }
      }

      function updateStock(variant) {
        var el = document.getElementById('product-stock-' + sectionId);
        if (!el) return;
        var html = '';
        var inv = (inventory && inventory[variant.id]) || {};
        var tOut = el.getAttribute('data-text-out') || 'Uitverkocht';
        var tLow = el.getAttribute('data-text-low') || 'Beperkt beschikbaar';
        var tOk = el.getAttribute('data-text-ok') || 'Op voorraad';
        var tOnlyLeft = el.getAttribute('data-text-only-left') || 'Nog maar [count] op voorraad';
        if (!variant.available) {
          html = '<span class="stock-badge stock-badge--out">' + tOut + '</span>';
        } else if (inv.management === 'shopify') {
          if (inv.quantity <= 3) {
            html = '<span class="stock-badge stock-badge--critical">' + tOnlyLeft.replace('[count]', inv.quantity) + '</span>';
          } else if (inv.quantity <= 20) {
            html = '<span class="stock-badge stock-badge--low">' + tLow + '</span>';
          } else {
            html = '<span class="stock-badge stock-badge--ok">' + tOk + '</span>';
          }
        } else {
          html = '<span class="stock-badge stock-badge--ok">' + tOk + '</span>';
        }
        el.innerHTML = html;
      }

      function updateButton(variant) {
        var btn = sectionEl.querySelector('.product-info__add-btn');
        if (!btn) return;
        btn.disabled = !variant.available;
        var span = btn.querySelector('span');
        if (span) span.textContent = variant.available ? addToCartText : soldOutText;
      }

      function updateNotify(variant) {
        var notifyEl = document.getElementById('product-notify-' + sectionId);
        if (!notifyEl) return;
        notifyEl.setAttribute('data-variant-id', variant.id);
        if (!variant.available) {
          notifyEl.removeAttribute('hidden');
        } else {
          notifyEl.setAttribute('hidden', '');
          var feedback = notifyEl.querySelector('.product-notify__feedback');
          if (feedback) feedback.setAttribute('hidden', '');
          var input = notifyEl.querySelector('.product-notify__input');
          if (input) input.value = '';
        }
      }

      // Klaviyo back-in-stock click handler (once per section)
      (function () {
        var notifyEl = document.getElementById('product-notify-' + sectionId);
        if (!notifyEl) return;
        var btn = notifyEl.querySelector('.product-notify__btn');
        var input = notifyEl.querySelector('.product-notify__input');
        var feedback = notifyEl.querySelector('.product-notify__feedback');
        if (!btn || !input) return;

        btn.addEventListener('click', function () {
          var email = input.value.trim();
          if (!email || !input.checkValidity()) {
            input.reportValidity();
            return;
          }
          var key = notifyEl.getAttribute('data-klaviyo-key') || 'RMQWZD';
          var variantId = notifyEl.getAttribute('data-variant-id');
          btn.disabled = true;
          btn.textContent = '...';

          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + key, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2023-12-15'
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  channels: ['EMAIL'],
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email: email }
                    }
                  }
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: '$shopify:::$default:::' + variantId
                    }
                  }
                }
              }
            })
          })
            .then(function (res) {
              return res.text().then(function (body) {
                if (feedback) {
                  feedback.removeAttribute('hidden');
                  if (res.ok) {
                    feedback.textContent = (function(){var e=document.querySelector('[data-product-section]');return (e && e.getAttribute('data-text-notify-confirmation')) || 'Je ontvangt een melding zodra dit product weer beschikbaar is.';})();
                    feedback.style.color = '#00b77f';
                    input.value = '';
                  } else {
                    feedback.textContent = 'HTTP ' + res.status + ': ' + body;
                    feedback.style.color = '#c00';
                  }
                }
              });
            })
            .catch(function (err) {
              if (feedback) {
                feedback.removeAttribute('hidden');
                feedback.textContent = 'Fout: ' + (err && err.message ? err.message : err);
                feedback.style.color = '#c00';
              }
            })
            .finally(function () {
              btn.disabled = false;
              btn.textContent = (function(){var e=document.querySelector('[data-product-section]');return (e && e.getAttribute('data-text-notify-subscribe')) || 'Meld me aan';})();
            });
        });
      })();

      function updateVariantInput(variant) {
        var input = sectionEl.querySelector('input[name="id"]');
        if (input) input.value = variant.id;
      }

      function updateGallery(variant) {
        if (!variant.featured_media) return;
        var item = sectionEl.querySelector('.product-gallery__item[data-media-id="' + variant.featured_media.id + '"]');
        if (item) item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      function applyVariant(variant) {
        if (!variant) return;
        updatePrice(variant);
        updateStock(variant);
        updateButton(variant);
        updateNotify(variant);
        updateVariantInput(variant);
        updateGallery(variant);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { sectionId: sectionId, available: variant.available }
        }));
      }

      function updateAvailability(changedIndex) {
        var optionCount = selectedOptions.length;
        for (var oi = 0; oi < optionCount; oi++) {
          if (oi === changedIndex) continue;
          var inStock = new Set();
          variants.forEach(function (v) {
            var matches = true;
            for (var j = 0; j < optionCount; j++) {
              if (j !== oi && v['option' + (j + 1)] !== selectedOptions[j]) { matches = false; break; }
            }
            if (matches && v.available) inStock.add(v['option' + (oi + 1)]);
          });
          sectionEl.querySelectorAll('[data-option-index="' + oi + '"]').forEach(function (btn) {
            var val = btn.getAttribute('data-value');
            btn.classList.toggle('opt-btn--sold-out', !inStock.has(val));
          });
        }
      }

      function getSelectedFromDOM() {
        var opts = [];
        var count = selectedOptions.length;
        for (var i = 0; i < count; i++) {
          var btn = sectionEl.querySelector('[data-option-index="' + i + '"].is-selected');
          opts.push(btn ? btn.getAttribute('data-value') : selectedOptions[i]);
        }
        return opts;
      }

      // Option button clicks
      sectionEl.querySelectorAll('.opt-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-option-index'));
          var val = btn.getAttribute('data-value');
          selectedOptions[idx] = val;

          sectionEl.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) {
            var active = b.getAttribute('data-value') === val;
            b.classList.toggle('is-selected', active);
            b.setAttribute('aria-pressed', String(active));
          });

          var labelEl = sectionEl.querySelector('[id^="opt-label-"][id$="-' + idx + '"]');
          if (labelEl) labelEl.textContent = val;

          updateAvailability(idx);
          applyVariant(findVariant(getSelectedFromDOM()));
        });
      });

      // Initialize state for the preselected variant on page load
      applyVariant(findVariant(getSelectedFromDOM()));

      // Add to cart via drawer
      var atcForm = sectionEl.querySelector('form[action*="/cart/add"]');
      if (atcForm) {
        atcForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var variantInput = atcForm.querySelector('input[name="id"]');
          if (!variantInput) return;
          var btn = atcForm.querySelector('button[type="submit"]');
          var origText = btn ? btn.textContent : '';
          if (btn) { btn.disabled = true; btn.textContent = '...'; }
          var bundleQty = parseInt(sectionEl.getAttribute('data-bundle-qty') || '1');
          var bundleDiscount = parseInt(sectionEl.getAttribute('data-bundle-discount') || '0');
          var reg = bundleRegistry[sectionId];
          var bodyData;
          var regTiersStr = (reg && reg.tiersStr) ? reg.tiersStr : '';
          // Find label from active tier, or fall back to first tier that has one
          var bundleLabel = sectionEl.getAttribute('data-bundle-label') || '';
          if (!bundleLabel && regTiersStr) {
            var anyLabelBtn = sectionEl.querySelector('[data-bundle-label]');
            if (anyLabelBtn) bundleLabel = anyLabelBtn.getAttribute('data-bundle-label') || '';
          }
          // Always send tier data when tiers exist so cart can recalculate dynamically
          var atcVid = parseInt(variantInput.value);
          var atcVarData = variants.find(function(v) { return v.id === atcVid; });
          var atcCompareAt = atcVarData ? (atcVarData.compare_at_price || 0) : 0;
          var baseProps = atcCompareAt > 0 ? { '_compare_at': String(atcCompareAt) } : {};
          if (regTiersStr) { baseProps['_bundle_tiers'] = regTiersStr; baseProps['_bundle_label'] = bundleLabel; }
          var bundleProps = Object.keys(baseProps).length > 0 ? baseProps : null;
          if (bundleQty > 1 && reg && reg.siblings && reg.slotProducts && reg.slotProducts.length === bundleQty) {
            var currentVariantId = parseInt(variantInput.value);
            var currentVariant = variants.find(function (v) { return v.id === currentVariantId; });
            var currentSize = currentVariant ? currentVariant.option1 : null;
            var items = reg.slotProducts.map(function (productId) {
              var sibling = reg.siblings.find(function (s) { return s.id === productId; });
              var vid;
              if (!sibling || sibling.current) {
                vid = currentVariantId;
              } else {
                var sibVariant = sibling.variants.find(function (v) { return v.option1 === currentSize; });
                vid = sibVariant ? sibVariant.id : sibling.variants[0].id;
              }
              return bundleProps ? { id: vid, quantity: 1, properties: bundleProps } : { id: vid, quantity: 1 };
            });
            bodyData = { items: items };
          } else {
            bodyData = bundleProps
              ? { id: parseInt(variantInput.value), quantity: bundleQty, properties: bundleProps }
              : { id: parseInt(variantInput.value), quantity: bundleQty };
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(bodyData)
          })
            .then(function (res) {
              if (!res.ok) throw new Error('cart/add ' + res.status);
              return res.json();
            })
            .then(function (data) {
              var firstItem = (data.items && data.items[0]) ? data.items[0] : data;
              document.dispatchEvent(new CustomEvent('cart:open'));
              window.mdq = window.mdq || [];
              window.mdq.push(['track', 'AddToCart', {
                content_ids: [String(firstItem.product_id)],
                content_name: firstItem.product_title,
                currency: 'EUR',
                value: firstItem.price / 100
              }]);
            })
            .catch(function () {})
            .finally(function () {
              // Cooldown: knop pas na 1 s weer actief — geeft cart:open tijd
              // om te laden en voorkomt dat de gebruiker te snel opnieuw klikt.
              setTimeout(function () {
                if (btn) { btn.disabled = false; btn.textContent = origText; }
              }, 1000);
            });
        });
      }
    });

    // ===== Bundle widget =====
    document.querySelectorAll('[data-bundle]').forEach(function (bundleEl) {
      var sectionId = bundleEl.getAttribute('data-bundle');
      var sectionEl = document.querySelector('[data-product-section="' + sectionId + '"]');
      var options = Array.from(bundleEl.querySelectorAll('[data-bundle-qty]'));
      var slotsEl = document.getElementById('bundle-slots-' + sectionId);
      var siblingsScript = document.getElementById('bundle-siblings-' + sectionId);

      var siblings = siblingsScript ? JSON.parse(siblingsScript.textContent) : null;
      var tiersStr = bundleEl.getAttribute('data-bundle-tiers') || '';
      if (!bundleRegistry[sectionId]) bundleRegistry[sectionId] = {};
      bundleRegistry[sectionId].siblings = siblings;
      bundleRegistry[sectionId].slotProducts = [];
      bundleRegistry[sectionId].tiersStr = tiersStr;

      // Show bundle label badge on price if any tier has a label
      var labelEl = document.getElementById('bundle-label-' + sectionId);
      if (labelEl) {
        var firstLabel = '';
        options.forEach(function (o) {
          if (!firstLabel) firstLabel = o.getAttribute('data-bundle-label') || '';
        });
        if (firstLabel) {
          labelEl.textContent = firstLabel;
          labelEl.removeAttribute('hidden');
        }
      }

      function getCurrentProductId() {
        if (!siblings) return null;
        var cur = siblings.find(function (s) { return s.current; });
        return cur ? cur.id : null;
      }

      function initSlots(qty) {
        var currentId = getCurrentProductId();
        var slots = [];
        for (var i = 0; i < qty; i++) slots.push(currentId);
        bundleRegistry[sectionId].slotProducts = slots;
        renderSlots();
      }

      function renderSlots() {
        if (!slotsEl || !siblings) return;
        var slotProducts = bundleRegistry[sectionId].slotProducts;
        slotsEl.innerHTML = '';

        // Section title
        var title = document.createElement('p');
        title.className = 'bundle-slots__title';
        title.textContent = (function(){var e=document.querySelector('[data-product-section]');return (e && e.getAttribute('data-text-bundle-color')) || 'Kies per item een kleur';})();
        slotsEl.appendChild(title);

        slotProducts.forEach(function (productId, idx) {
          var row = document.createElement('div');
          row.className = 'bundle-slot';

          // Left column: item number + selected color name
          var info = document.createElement('div');
          info.className = 'bundle-slot__info';

          var labelEl = document.createElement('span');
          labelEl.className = 'bundle-slot__label';
          labelEl.textContent = 'Item ' + (idx + 1);
          info.appendChild(labelEl);

          var activeSibling = siblings.find(function (s) { return s.id === productId; });
          if (activeSibling) {
            var colorEl = document.createElement('span');
            colorEl.className = 'bundle-slot__color';
            colorEl.textContent = activeSibling.color;
            info.appendChild(colorEl);
          }

          row.appendChild(info);

          // Right column: swatches
          var swatchesEl = document.createElement('div');
          swatchesEl.className = 'bundle-slot__swatches';

          siblings.forEach(function (sibling) {
            var swatch = document.createElement('button');
            swatch.type = 'button';
            swatch.className = 'bundle-slot__swatch';
            swatch.setAttribute('title', sibling.color);
            swatch.setAttribute('aria-label', sibling.color);
            if (sibling.id === productId) swatch.classList.add('bundle-slot__swatch--active');
            if (sibling.image) {
              var img = document.createElement('img');
              img.src = sibling.image;
              img.alt = sibling.color;
              img.width = 52;
              img.height = 52;
              swatch.appendChild(img);
            } else {
              swatch.style.backgroundColor = colorMap[(sibling.color || '').toLowerCase()] || '#ddd';
            }
            swatch.addEventListener('click', function () {
              bundleRegistry[sectionId].slotProducts[idx] = sibling.id;
              renderSlots();
            });
            swatchesEl.appendChild(swatch);
          });

          row.appendChild(swatchesEl);
          slotsEl.appendChild(row);
        });
      }

      bundleRegistry[sectionId].render = renderSlots;

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          var qty = parseInt(option.getAttribute('data-bundle-qty'));
          options.forEach(function (o) {
            o.classList.remove('product-bundle__option--active');
            o.setAttribute('aria-pressed', 'false');
          });
          option.classList.add('product-bundle__option--active');
          option.setAttribute('aria-pressed', 'true');
          if (sectionEl) {
            sectionEl.setAttribute('data-bundle-qty', qty);
            sectionEl.setAttribute('data-bundle-discount', option.getAttribute('data-bundle-discount') || '0');
            sectionEl.setAttribute('data-bundle-label', option.getAttribute('data-bundle-label') || '');
          }


          if (slotsEl && siblings && siblings.length > 1) {
            if (qty > 1) {
              initSlots(qty);
              slotsEl.removeAttribute('hidden');
            } else {
              slotsEl.setAttribute('hidden', '');
              bundleRegistry[sectionId].slotProducts = [];
            }
          }
        });
      });
    });

    // Re-render bundle slots when variant/size changes
    document.addEventListener('variant:change', function (e) {
      var reg = bundleRegistry[e.detail.sectionId];
      if (reg && reg.render && reg.slotProducts && reg.slotProducts.length > 0) reg.render();
    });

    // ===== Upsell slider =====
    document.querySelectorAll('.product-upsell').forEach(function (upsell) {
      var track = upsell.querySelector('.product-upsell__track');
      var prevBtn = upsell.querySelector('.product-upsell__arrow--prev');
      var nextBtn = upsell.querySelector('.product-upsell__arrow--next');
      if (!track) return;

      var cards = Array.from(track.querySelectorAll('.product-upsell__card'));
      var total = cards.length;
      var current = 0;

      function getVisible() {
        return Math.round(upsell.querySelector('.product-upsell__track-wrap').offsetWidth / (cards[0] ? cards[0].offsetWidth + 12 : 1));
      }

      function goTo(idx) {
        var visible = getVisible();
        current = Math.max(0, Math.min(idx, total - visible));
        var cardWidth = cards[0] ? cards[0].offsetWidth + 12 : 0;
        track.style.transform = 'translateX(-' + (current * cardWidth) + 'px)';
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current >= total - visible;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
      goTo(0);
      window.addEventListener('resize', function () { goTo(current); }, { passive: true });

      // Touch swipe
      var touchStartX = 0;
      track.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var delta = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 40) goTo(current + (delta > 0 ? 1 : -1));
      }, { passive: true });

      // Add to cart buttons
      upsell.querySelectorAll('[data-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = btn.closest('.product-upsell__card');
          var select = card ? card.querySelector('[data-upsell-select]') : null;
          var variantId = select ? parseInt(select.value) : parseInt(btn.getAttribute('data-variant-id'));
          if (!variantId) return;
          window.CartQ.add({ id: variantId, quantity: 1 }, btn);
        });
      });
    });

    // ===== Accordions: only one open at a time across entire product-info =====
    document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
      var btn = accordion.querySelector('.product-accordion__summary');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = accordion.classList.contains('is-open');
        var scope = accordion.closest('.product-info') || document;
        scope.querySelectorAll('[data-accordion]').forEach(function (a) {
          a.classList.remove('is-open');
          var s = a.querySelector('.product-accordion__summary');
          if (s) s.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          accordion.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // ===== Gallery: mobile dots + desktop lightbox =====
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var galleryId = gallery.getAttribute('data-gallery');
      var dotsContainer = document.querySelector('[data-gallery-dots="' + galleryId + '"]');
      var lightbox = document.querySelector('[data-lightbox="' + galleryId + '"]');
      var items = Array.from(gallery.querySelectorAll('.product-gallery__item'));
      var total = items.length;

      if (dotsContainer && total > 1) {
        var dots = Array.from(dotsContainer.querySelectorAll('.product-gallery__strip'));
        gallery.addEventListener('scroll', function () {
          var idx = Math.round(gallery.scrollLeft / gallery.offsetWidth);
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }, { passive: true });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            gallery.scrollTo({ left: parseInt(dot.getAttribute('data-index')) * gallery.offsetWidth, behavior: 'smooth' });
          });
        });
      }

      if (lightbox) {
        var track = lightbox.querySelector('.product-lightbox__track');
        var prevBtn = lightbox.querySelector('.product-lightbox__nav--prev');
        var nextBtn = lightbox.querySelector('.product-lightbox__nav--next');
        var currentEl = lightbox.querySelector('.js-lightbox-current');
        var current = 0;
        var slides = Array.from(lightbox.querySelectorAll('.product-lightbox__slide'));

        function resetSlideZoom(slide) {
          var img = slide.querySelector('.product-lightbox__img');
          slide._scale = 1; slide._panX = 0; slide._panY = 0;
          img.style.transition = ''; img.style.transform = '';
        }

        slides.forEach(function (slide) { slide._scale = 1; slide._panX = 0; slide._panY = 0; });

        function goTo(idx, instant) {
          var prev = slides[current];
          current = Math.max(0, Math.min(idx, total - 1));
          if (prev) resetSlideZoom(prev);
          track.style.overflowX = '';
          if (instant) {
            track.scrollLeft = current * track.offsetWidth;
          } else {
            track.scrollTo({ left: current * track.offsetWidth, behavior: 'smooth' });
          }
          if (currentEl) currentEl.textContent = current + 1;
          if (prevBtn) prevBtn.toggleAttribute('hidden', current === 0);
          if (nextBtn) nextBtn.toggleAttribute('hidden', current === total - 1);
        }

        function openLightbox(idx) {
          lightbox.showModal();
          document.body.style.overflow = 'hidden';
          goTo(idx, true);
        }

        function closeLightbox() {
          slides.forEach(resetSlideZoom);
          track.style.overflowX = '';
          lightbox.close();
          document.body.style.overflow = '';
        }

        slides.forEach(function (slide) {
          var img = slide.querySelector('.product-lightbox__img');
          var startDist = 0, startScale = 1;
          var startPanX = 0, startPanY = 0, startTX = 0, startTY = 0;
          var lastTap = 0;

          function applyTransform(animated) {
            if (animated) {
              img.style.transition = 'transform 0.25s ease';
              setTimeout(function () { img.style.transition = ''; }, 250);
            }
            img.style.transform = 'scale(' + slide._scale + ') translate(' + (slide._panX / slide._scale) + 'px, ' + (slide._panY / slide._scale) + 'px)';
          }

          slide.addEventListener('touchstart', function (e) {
            var now = Date.now();
            if (e.touches.length === 1 && now - lastTap < 300) {
              e.preventDefault();
              if (slide._scale > 1) {
                resetSlideZoom(slide); img.style.transition = 'transform 0.25s ease'; img.style.transform = ''; setTimeout(function () { img.style.transition = ''; }, 250); track.style.overflowX = '';
              } else {
                slide._scale = 2.5; applyTransform(true); track.style.overflowX = 'hidden';
              }
            }
            lastTap = now;
            if (e.touches.length === 2) {
              e.preventDefault();
              startDist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
              startScale = slide._scale; startPanX = slide._panX; startPanY = slide._panY;
              startTX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
              startTY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            } else if (e.touches.length === 1 && slide._scale > 1) {
              startPanX = slide._panX; startPanY = slide._panY;
              startTX = e.touches[0].clientX; startTY = e.touches[0].clientY;
            }
          }, { passive: false });

          slide.addEventListener('touchmove', function (e) {
            if (e.touches.length === 2) {
              e.preventDefault();
              var dist = Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY);
              slide._scale = Math.min(5, Math.max(1, startScale * (dist / startDist)));
              var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
              var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
              slide._panX = startPanX + mx - startTX;
              slide._panY = startPanY + my - startTY;
              applyTransform(false);
              track.style.overflowX = 'hidden';
            } else if (e.touches.length === 1 && slide._scale > 1) {
              e.preventDefault();
              slide._panX = startPanX + e.touches[0].clientX - startTX;
              slide._panY = startPanY + e.touches[0].clientY - startTY;
              applyTransform(false);
            }
          }, { passive: false });

          slide.addEventListener('touchend', function () {
            if (slide._scale < 1.05) { resetSlideZoom(slide); track.style.overflowX = ''; }
          });

          // Desktop click-to-zoom
          var mouseDownX, mouseDownY;
          slide.addEventListener('mousedown', function (e) { mouseDownX = e.clientX; mouseDownY = e.clientY; });
          slide.addEventListener('click', function (e) {
            if (Math.abs(e.clientX - mouseDownX) > 4 || Math.abs(e.clientY - mouseDownY) > 4) return;
            if (slide._scale > 1) {
              resetSlideZoom(slide);
              img.style.transition = 'transform 0.25s ease';
              img.style.transform = '';
              setTimeout(function () { img.style.transition = ''; }, 250);
              track.style.overflowX = '';
              slide.style.cursor = 'zoom-in';
            } else {
              var rect = img.getBoundingClientRect();
              var originX = ((e.clientX - rect.left) / rect.width * 100).toFixed(1) + '%';
              var originY = ((e.clientY - rect.top) / rect.height * 100).toFixed(1) + '%';
              img.style.transformOrigin = originX + ' ' + originY;
              slide._scale = 2.5;
              applyTransform(true);
              track.style.overflowX = 'hidden';
              slide.style.cursor = 'zoom-out';
            }
          });
          slide.style.cursor = 'zoom-in';
        });

        items.forEach(function (item) {
          item.addEventListener('click', function () {
            openLightbox(parseInt(item.getAttribute('data-index')));
          });
        });

        if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

        lightbox.querySelector('.product-lightbox__close').addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
        lightbox.addEventListener('cancel', function (e) { e.preventDefault(); closeLightbox(); });

        document.addEventListener('keydown', function (e) {
          if (!lightbox.open) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
          if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
        });

        track.addEventListener('scroll', function () {
          var idx = Math.round(track.scrollLeft / track.offsetWidth);
          if (idx !== current) {
            current = idx;
            if (currentEl) currentEl.textContent = current + 1;
            if (prevBtn) prevBtn.toggleAttribute('hidden', current === 0);
            if (nextBtn) nextBtn.toggleAttribute('hidden', current === total - 1);
          }
        }, { passive: true });
      }
    });

    // ===== Size guide panel =====
    var sizeGuideDialog = document.querySelector('.size-guide-dialog');
    if (sizeGuideDialog) {
      var sizeGuidePanel = sizeGuideDialog.querySelector('.size-guide-dialog__panel');

      function openSizeGuide() {
        sizeGuideDialog.showModal();
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(function () {
          sizeGuideDialog.classList.add('size-guide-dialog--visible');
        });
      }

      function closeSizeGuide() {
        sizeGuideDialog.classList.remove('size-guide-dialog--visible');
        sizeGuideDialog.classList.add('size-guide-dialog--closing');
        sizeGuidePanel.addEventListener('transitionend', function handler() {
          sizeGuidePanel.removeEventListener('transitionend', handler);
          sizeGuideDialog.classList.remove('size-guide-dialog--closing');
          sizeGuideDialog.close();
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
        }, { once: true });
      }

      document.addEventListener('click', function (e) {
        if (e.target.closest('.size-guide-trigger')) openSizeGuide();
        if (e.target.closest('.size-guide-dialog__close') || e.target === sizeGuideDialog.querySelector('.size-guide-dialog__overlay')) closeSizeGuide();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeGuideDialog.open) { e.preventDefault(); closeSizeGuide(); }
      });

      sizeGuideDialog.addEventListener('cancel', function (e) { e.preventDefault(); closeSizeGuide(); });
    }

    // ===== Size calculator popup =====
    var sizeCalcDialog = document.querySelector('.size-calc-dialog');
    if (sizeCalcDialog) {
      var sizeCalcInner = sizeCalcDialog.querySelector('.size-calc-dialog__inner');

      function openSizeCalc() {
        sizeCalcDialog.showModal();
        document.body.style.overflow = 'hidden';
        sizeCalcDialog.offsetHeight;
        requestAnimationFrame(function () {
          sizeCalcDialog.classList.add('size-calc-dialog--visible');
        });
      }

      function closeSizeCalc() {
        sizeCalcDialog.classList.remove('size-calc-dialog--visible');
        sizeCalcInner.addEventListener('transitionend', function handler() {
          sizeCalcInner.removeEventListener('transitionend', handler);
          sizeCalcDialog.close();
          document.body.style.overflow = '';
        }, { once: true });
      }

      document.addEventListener('click', function (e) {
        if (e.target.closest('.size-guide-calc-trigger')) openSizeCalc();
        if (e.target.closest('.size-calc-dialog__close')) closeSizeCalc();
        if (e.target.closest('.size-calc-dialog') && !e.target.closest('.size-calc-dialog__inner')) closeSizeCalc();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sizeCalcDialog.open) { e.preventDefault(); closeSizeCalc(); }
      });

      sizeCalcDialog.addEventListener('cancel', function (e) { e.preventDefault(); closeSizeCalc(); });

      sizeCalcDialog.querySelectorAll('.size-calc-build__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizeCalcDialog.querySelectorAll('.size-calc-build__btn').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
        });
      });

      var resultEl = sizeCalcDialog.querySelector('.size-calc-result');
      var resultSizeEl = sizeCalcDialog.querySelector('.size-calc-result__size');
      var manualInput = sizeCalcDialog.querySelector('#size-calc-chest');
      var manualLabel = sizeCalcDialog.querySelector('label[for="size-calc-chest"]');

      function detectMeasurementType(data) {
        if (!data || !data.rows) return null;
        var rows = data.rows;
        for (var i = 0; i < rows.length; i++) {
          var label = rows[i][0] ? rows[i][0].toLowerCase() : '';
          if (label.indexOf('borst') !== -1) return 'borst';
        }
        for (var i = 0; i < rows.length; i++) {
          var label = rows[i][0] ? rows[i][0].toLowerCase() : '';
          if (label.indexOf('taille') !== -1) return 'taille';
        }
        for (var i = 0; i < rows.length; i++) {
          var label = rows[i][0] ? rows[i][0].toLowerCase() : '';
          if (label.indexOf('heup') !== -1) return 'heup';
        }
        return null;
      }

      function findRowByKeyword(data, keyword) {
        return data.rows.find(function (row) {
          return row[0] && row[0].toLowerCase().indexOf(keyword) !== -1;
        });
      }

      function estimateMeasurement(height, weight, build, type) {
        var adj = build === 'slank' ? -3 : build === 'gespierd' ? 4 : build === 'breed' ? 7 : 0;
        if (type === 'borst') {
          return 0.53 * height + 0.47 * weight - 33 + adj;
        }
        if (type === 'taille') {
          return height * 0.43 + (weight - 70) * 0.35 + adj;
        }
        if (type === 'heup') {
          return height * 0.54 + (weight - 70) * 0.3 + adj;
        }
        return null;
      }

      function findSizeFromMeasurement(bodyMeasurement, data, type) {
        var keyword = type === 'borst' ? 'borst' : type === 'taille' ? 'taille' : 'heup';
        var row = findRowByKeyword(data, keyword);
        if (!row || !data.columns) return null;
        var compare = bodyMeasurement * 0.5;
        var best = null;
        var bestDiff = Infinity;
        for (var i = 1; i < row.length; i++) {
          var val = parseFloat(row[i]);
          if (isNaN(val)) continue;
          if (val >= compare) {
            var diff = val - compare;
            if (diff < bestDiff) { bestDiff = diff; best = data.columns[i]; }
          }
        }
        return best || data.columns[row.length - 1];
      }

      var calcDialog = document.querySelector('.size-calc-dialog');
      var manualLabels = {
        borst: (calcDialog && calcDialog.getAttribute('data-label-chest')) || 'Of vul je borstomtrek in (cm)',
        taille: (calcDialog && calcDialog.getAttribute('data-label-waist')) || 'Of vul je tailleomtrek in (cm)',
        heup: (calcDialog && calcDialog.getAttribute('data-label-hip')) || 'Of vul je heupomtrek in (cm)'
      };

      function showResult(size) {
        resultSizeEl.textContent = size;
        resultEl.removeAttribute('hidden');
      }

      var submitBtn = sizeCalcDialog.querySelector('.size-calc-dialog__submit');
      submitBtn.addEventListener('click', function () {
        if (!window.sizeGuideData) return;
        var height = parseFloat(sizeCalcDialog.querySelector('#size-calc-height').value);
        var weight = parseFloat(sizeCalcDialog.querySelector('#size-calc-weight').value);
        var buildBtn = sizeCalcDialog.querySelector('.size-calc-build__btn.is-selected');
        var build = buildBtn ? buildBtn.dataset.build : 'gemiddeld';
        if (isNaN(height) || isNaN(weight)) return;

        var type = detectMeasurementType(window.sizeGuideData);
        if (!type) return;

        var measurement = estimateMeasurement(height, weight, build, type);
        var size = findSizeFromMeasurement(measurement, window.sizeGuideData, type);
        if (!size) return;

        if (manualLabel) manualLabel.textContent = manualLabels[type] || manualLabels.borst;
        manualInput.value = '';
        showResult(size);
      });

      if (manualInput) {
        manualInput.addEventListener('input', function () {
          if (!window.sizeGuideData) return;
          var val = parseFloat(manualInput.value);
          if (isNaN(val) || val < 40) return;
          var type = detectMeasurementType(window.sizeGuideData);
          if (!type) return;
          var size = findSizeFromMeasurement(val, window.sizeGuideData, type);
          if (size) showResult(size);
        });
      }
    }
  })();

  // ===== Sticky ATC bar (mobile only) =====
  (function () {
    var originalBtn = document.querySelector('.product-info__add-btn');
    var stickyBar = document.querySelector('.product-sticky-atc');
    if (!originalBtn || !stickyBar) return;

    var stickyBtn = stickyBar.querySelector('.product-sticky-atc__btn');
    var stickyPrice = stickyBar.querySelector('.product-sticky-atc__price');
    var stickySelect = stickyBar.querySelector('.product-sticky-atc__select');
    if (!stickyBtn) return;

    var footer = document.querySelector('.footer');

    function update() {
      var rect = originalBtn.getBoundingClientRect();
      var btnInView = rect.top < window.innerHeight && rect.bottom > 0;
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var hidden = btnInView || footerVisible;
      stickyBar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      stickyBtn.disabled = originalBtn.disabled;
    }

    window.addEventListener('scroll', update, { passive: true });
    update();

    // Sync price and select when variant changes
    document.addEventListener('variant:change', function () {
      stickyBtn.disabled = originalBtn.disabled;
      if (stickyPrice) {
        var priceContainer = document.querySelector('.product-info__price');
        var activePriceSel = priceContainer && priceContainer.classList.contains('has-sale') ? '.product-info__price-sale'
          : '.product-info__price-regular';
        var priceEl = priceContainer && priceContainer.querySelector(activePriceSel);
        if (priceEl) stickyPrice.textContent = priceEl.textContent;
      }
      if (stickySelect) {
        var idx = stickySelect.dataset.stickySizeIndex;
        var activeBtn = document.querySelector('.opt-btn.is-selected[data-option-index="' + idx + '"]');
        if (activeBtn) stickySelect.value = activeBtn.dataset.value;
      }
    });

    // Sticky select → click matching main option button
    if (stickySelect) {
      stickySelect.addEventListener('change', function () {
        var idx = stickySelect.dataset.stickySizeIndex;
        var btn = document.querySelector('.opt-btn[data-option-index="' + idx + '"][data-value="' + stickySelect.value + '"]');
        if (btn) btn.click();
      });
    }

    stickyBtn.addEventListener('click', function () {
      originalBtn.click();
    });
  })();

  // ===== Mobile: sticky photo auto-scroll + announcement bar =====
  (function () {
    if (window.innerWidth > 749) return;

    // Auto-scroll on load so product info is immediately visible
    if (window.scrollY === 0) {
      window.scrollTo(0, 140);
    }

    // Announcement bar: hidden on load, visible on scroll up
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;

    bar.classList.add('announcement-bar--scroll-hidden');

    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < lastY) {
        bar.classList.remove('announcement-bar--scroll-hidden');
      } else if (y > lastY) {
        bar.classList.add('announcement-bar--scroll-hidden');
      }
      lastY = y;
    }, { passive: true });
  })();

  // ===== Shop the Look =====
  (function () {
    document.querySelectorAll('.product-stl').forEach(function (stl) {
      stl.addEventListener('click', function (e) {
        var sizeBtn = e.target.closest('[data-stl-size]');
        var addBtn = e.target.closest('[data-stl-add]');

        if (sizeBtn && !sizeBtn.disabled) {
          var item = sizeBtn.closest('.product-stl__item');
          item.querySelectorAll('[data-stl-size]').forEach(function (b) {
            b.classList.remove('product-stl__size--active');
          });
          sizeBtn.classList.add('product-stl__size--active');
          var add = item.querySelector('[data-stl-add]');
          add.dataset.variantId = sizeBtn.dataset.variantId;
          add.disabled = false;
        }

        if (addBtn && !addBtn.disabled) {
          var variantId = addBtn.dataset.variantId;
          if (!variantId) return;
          window.CartQ.add({ id: parseInt(variantId, 10), quantity: 1 }, addBtn, (function(){var e=document.querySelector('[data-product-section]');return (e && e.getAttribute('data-text-add')) || 'Toevoegen';})());
        }
      });
    });
  })();
  document.querySelectorAll('.product-discount-code__countdown').forEach(function(el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    function update() {
      var diff = target - Date.now();
      if (diff <= 0) { el.style.display = 'none'; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var parts = [];
      if (d > 0) parts.push(d + 'd');
      parts.push(String(h).padStart(2, '0') + 'u');
      parts.push(String(m).padStart(2, '0') + 'm');
      parts.push(String(s).padStart(2, '0') + 's');
      el.textContent = parts.join(' ');
      setTimeout(update, 1000);
    }
    update();
  });

  document.querySelectorAll('.product-discount-code__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var code = btn.getAttribute('data-code');

      function onCopied() {
        btn.setAttribute('data-copied', '');
        setTimeout(function() { btn.removeAttribute('data-copied'); }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(onCopied).catch(function() {
          fallbackCopy(code, onCopied);
        });
      } else {
        fallbackCopy(code, onCopied);
      }
    });
  });

  function fallbackCopy(text, callback) {
    var el = document.createElement('textarea');
    el.value = text;
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.focus();
    el.select();
    try { document.execCommand('copy'); callback(); } catch(e) {}
    document.body.removeChild(el);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('related-products-{{ section.id }}');
    if (!section) return;

    var track = section.querySelector('.related-products__track');
    var prevBtn = section.querySelector('.related-products__btn--prev');
    var nextBtn = section.querySelector('.related-products__btn--next');

    if (!prevBtn || !nextBtn || !track) return;

    function getScrollAmount() {
      var card = track.querySelector('.product-card');
      if (!card) return 300;
      var gap = parseFloat(getComputedStyle(track).gap) || 4;
      return card.offsetWidth + gap;
    }

    function updateButtons() {
      prevBtn.style.opacity = track.scrollLeft <= 0 ? '0.3' : '1';
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      nextBtn.style.opacity = atEnd ? '0.3' : '1';
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.reviews-section__wrapper').forEach(function (wrapper) {
      var track = wrapper.querySelector('.reviews-section__track');
      var prevBtn = wrapper.querySelector('.reviews-section__btn--prev');
      var nextBtn = wrapper.querySelector('.reviews-section__btn--next');
      if (!track) return;

      // Clone slides for infinite loop: prepend + append a copy
      var originals = Array.from(track.querySelectorAll('.review-card'));
      if (originals.length < 2) return;

      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.insertBefore(clone, track.firstChild);
      });

      function cardWidth() {
        var card = track.querySelector('.review-card');
        if (!card) return 300;
        return card.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 16);
      }

      // Start in the middle set
      var jumping = false;
      track.scrollLeft = cardWidth() * originals.length;

      track.addEventListener('scroll', function () {
        if (jumping) return;
        var setWidth = cardWidth() * originals.length;
        if (track.scrollLeft < setWidth * 0.5) {
          jumping = true;
          track.scrollLeft += setWidth;
          jumping = false;
        } else if (track.scrollLeft >= setWidth * 1.5) {
          jumping = true;
          track.scrollLeft -= setWidth;
          jumping = false;
        }
      }, { passive: true });

      if (prevBtn) {
        prevBtn.removeAttribute('hidden');
        prevBtn.addEventListener('click', function () { track.scrollBy({ left: -cardWidth(), behavior: 'smooth' }); });
      }
      if (nextBtn) {
        nextBtn.removeAttribute('hidden');
        nextBtn.addEventListener('click', function () { track.scrollBy({ left: cardWidth(), behavior: 'smooth' }); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
